import { useEffect, useState } from 'react';

/** Returns `value` once it has stopped changing for `delayMs`. A `delayMs` of 0 passes it straight through. */
export const useDebouncedValue = <T>(value: T, delayMs: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (!delayMs) {
      return;
    }

    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);

    return () => clearTimeout(timeoutId);
  }, [value, delayMs]);

  return delayMs ? debouncedValue : value;
};
